<div class="workspace">
  <mode-workspace-avatar class="avatar"
    shape="circle"
    [type]="avatarDetails.type"
    [initials]="avatarDetails.initials"
    [colorClass]="avatarDetails.colorClass"
    [imageSrc]="avatarDetails.imageSrc"
    [imageName]="avatarDetails.type"
    [isCommunity]="isCommunity"
  ></mode-workspace-avatar>
  <div class="header-badge-container">
    <h4 class="header">
      {{ header }}
    </h4>
    <capra-badge *ngIf="current"
      text="Current"
      type="green"
    ></capra-badge>
  </div>
  <p class="description">
    <ng-content></ng-content>
  </p>
</div>

<div class="button-container">
  <ng-container *ngIf="hovering">
    <capra-button
      *ngIf="connectDatabaseElementId && !isCommunity; else standardButtonTemplate"
      text="Switch"
      variant="secondary"
      color="neutral"
      [disabled]="current"
      (clicked)="switchWorkspace(true)"
    ></capra-button>
    <ng-template #standardButtonTemplate>
      <capra-button
        text="Switch"
        variant="secondary"
        color="neutral"
        [disabled]="current"
        (clicked)="switchWorkspace(false)"
      ></capra-button>
    </ng-template>
  </ng-container>
</div>
